import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import capitalize from "lodash/capitalize";
import { useMemo } from "react";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
export const CustomFieldTypeLabel = (param)=>{
    let { fieldTypeId, fieldTypes } = param;
    const fieldType = useMemo(()=>{
        return fieldTypes.find((ft)=>ft.id === fieldTypeId);
    }, [
        fieldTypeId,
        fieldTypes
    ]);
    if (!fieldType) return null;
    const Icon = customFieldIconMap[fieldType.title];
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            Icon && /*#__PURE__*/ _jsx(Icon, {
                className: "size-4 text-grey-10"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "grow",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text-14 text-grey-12",
                    children: capitalize(fieldType.title)
                })
            })
        ]
    });
};
